import * as React from 'react';

export default function CountdownTuesday() {
  const [daysUntil, setDaysUntil] = React.useState(null);
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    const calculateDays = () => {
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, 2 = Tuesday, etc.

      // Calculate days until next Tuesday (day 2)
      let daysToTuesday;
      if (dayOfWeek === 2) {
        // It's Tuesday!
        daysToTuesday = 0;
      } else if (dayOfWeek < 2) {
        // Sunday (0) or Monday (1)
        daysToTuesday = 2 - dayOfWeek;
      } else {
        // Wednesday (3) through Saturday (6)
        daysToTuesday = 7 - dayOfWeek + 2;
      }

      setDaysUntil(daysToTuesday);

      // Set appropriate message
      if (daysToTuesday === 0) {
        setMessage("Het is DINSDAG! Vandaag hakken we erop los!");
      } else if (daysToTuesday === 1) {
        setMessage("Nog 1 nachtje slapen... Morgen is het zover!");
      } else {
        setMessage(`Nog ${daysToTuesday} dagen tot de volgende ronde!`);
      }
    };

    calculateDays();
  }, []);

  if (daysUntil === null) return null;

  const isGameDay = daysUntil === 0;

  return (
    <div style={{
      padding: '15px 20px',
      background: isGameDay
        ? 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)'
        : 'linear-gradient(135deg, #1976D2 0%, #0D47A1 100%)',
      borderRadius: '12px',
      color: 'white',
      textAlign: 'center',
      marginBottom: '20px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
    }}>
      <div style={{
        fontSize: isGameDay ? '24px' : '36px',
        fontWeight: 'bold',
        marginBottom: '5px'
      }}>
        {isGameDay ? '⛳' : daysUntil}
      </div>
      <div style={{
        fontSize: '14px',
        opacity: 0.95
      }}>
        {message}
      </div>
    </div>
  );
}
